export const modalTabSelector = (state) => state.modal.tabModal
